import type { RequestLocalStorageKey } from ':shared/enums';
import type { RequestDetails } from ':shared/interfaces';

import { LIMITS_AND_TIME_BY_LOCAL_KEY } from ':shared/constants';
import { getRequestDetailsFromLocalStorage } from ':shared/utils/get-request-details-from-localstorage';

export const buildNewRequestDetails = ({
    key,
    shouldIncreaseCount,
}: {
    key: RequestLocalStorageKey;
    shouldIncreaseCount: boolean;
}): RequestDetails => {
    const currentTime = Date.now();
    const requestDetails = getRequestDetailsFromLocalStorage(key);
    const limitWithTime = LIMITS_AND_TIME_BY_LOCAL_KEY[key];

    const elapsedTime = currentTime - requestDetails.lastUpdatedAt;
    if (elapsedTime > limitWithTime.time) {
        requestDetails.requestCount = 0;
    }
    const willExceedLimit = requestDetails.requestCount >= limitWithTime.limit;
    if (!willExceedLimit) {
        requestDetails.lastUpdatedAt = currentTime;
    }
    if (shouldIncreaseCount) {
        requestDetails.requestCount += 1;
    }
    return requestDetails;
};
